import { Paper } from '@mui/material';
import React from 'react';

const PaperBase = ({
  children,
  backgroundColor,
  color,
  outline,
  className,
  style,
  py = 2,
  px = 2,
  ...props
}) => {
  return (
    <Paper
      elevation={0}
      className={[
        'flex justify-center items-center text-center text-sm',
        `py-${py} px-${px}`,
        className
      ].join(' ')}
      style={{
        backgroundColor,
        color,
        outline: outline ? outline : `1px solid var(--background)`,
        ...style
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default PaperBase;
